import styled from "styled-components";
import PropTypes from "prop-types";
import { device } from "../device";

const BlockMargin = styled.div`
    margin-bottom: ${({margin}) => 
        margin === '96' ? '64px' :
        margin === '64' ? '48px' : 
        margin === '48' ? '32px' : 
        '48px'
    };
    @media ${device.lg} {
        margin-bottom: ${({margin}) => 
            margin === '96' ? '96px' :
            margin === '64' ? '64px' : 
            margin === '48' ? '48px' : 
            '64px'
        };
    }
`;

BlockMargin.propTypes = {
    margin: PropTypes.string
};

export default BlockMargin;